/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * @version: 1.0 Alpha-1
 * @author: Coolite Inc. http://www.coolite.com/
 * @date: 2008-05-13
 * @copyright: Copyright (c) 2006-2008, Coolite Inc. (http://www.coolite.com/). All rights reserved.
 * @license: Licensed under The MIT License. See license.txt and http://www.datejs.com/license/.
 * @website: http://www.datejs.com/
 */
Date.CultureInfo = {
  name: "es-ES",
  englishName: "Spanish (Spain)",
  nativeName: "español (España)",
  dayNames: [
    "domingo",
    "lunes",
    "martes",
    "miércoles",
    "jueves",
    "viernes",
    "sábado",
  ],
  abbreviatedDayNames: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
  shortestDayNames: ["do", "lu", "ma", "mi", "ju", "vi", "sá"],
  firstLetterDayNames: ["d", "l", "m", "m", "j", "v", "s"],
  monthNames: [
    "enero",
    "febrero",
    "marzo",
    "abril",
    "mayo",
    "junio",
    "julio",
    "agosto",
    "septiembre",
    "octubre",
    "noviembre",
    "diciembre",
  ],
  abbreviatedMonthNames: [
    "ene",
    "feb",
    "mar",
    "abr",
    "may",
    "jun",
    "jul",
    "ago",
    "sep",
    "oct",
    "nov",
    "dic",
  ],
  amDesignator: "",
  pmDesignator: "",
  firstDayOfWeek: 1,
  twoDigitYearMax: 2029,
  dateElementOrder: "dmy",
  formatPatterns: {
    shortDate: "dd/MM/yyyy",
    longDate: "dddd, dd' de 'MMMM' de 'yyyy",
    shortTime: "H:mm",
    longTime: "H:mm:ss",
    fullDateTime: "dddd, dd' de 'MMMM' de 'yyyy H:mm:ss",
    sortableDateTime: "yyyy-MM-ddTHH:mm:ss",
    universalSortableDateTime: "yyyy-MM-dd HH:mm:ssZ",
    rfc1123: "ddd, dd MMM yyyy HH:mm:ss GMT",
    monthDay: "dd MMMM",
    yearMonth: "MMMM' de 'yyyy",
  },
  regexPatterns: {
    jan: /^ene(ro)?/i,
    feb: /^feb(rero)?/i,
    mar: /^mar(zo)?/i,
    apr: /^abr(il)?/i,
    may: /^may(o)?/i,
    jun: /^jun(io)?/i,
    jul: /^jul(io)?/i,
    aug: /^ago(sto)?/i,
    sep: /^sep(tiembre)?/i,
    oct: /^oct(ubre)?/i,
    nov: /^nov(iembre)?/i,
    dec: /^dic(iembre)?/i,
    sun: /^do(m(ingo)?)?/i,
    mon: /^lu(n(es)?)?/i,
    tue: /^ma(r(tes)?)?/i,
    wed: /^mi(é(rcoles)?)?/i,
    thu: /^ju(e(ves)?)?/i,
    fri: /^vi(e(rnes)?)?/i,
    sat: /^sá(b(ado)?)?/i,
    future: /^next/i,
    past: /^last|past|prev(ious)?/i,
    add: /^(\+|aft(er)?|from|hence)/i,
    subtract: /^(\-|bef(ore)?|ago)/i,
    yesterday: /^yes(terday)?/i,
    today: /^t(od(ay)?)?/i,
    tomorrow: /^tom(orrow)?/i,
    now: /^n(ow)?/i,
    millisecond: /^ms|milli(second)?s?/i,
    second: /^sec(ond)?s?/i,
    minute: /^mn|min(ute)?s?/i,
    hour: /^h(our)?s?/i,
    week: /^w(eek)?s?/i,
    month: /^m(onth)?s?/i,
    day: /^d(ay)?s?/i,
    year: /^y(ear)?s?/i,
    shortMeridian: /^(a|p)/i,
    longMeridian: /^(a\.?m?\.?|p\.?m?\.?)/i,
    timezone:
      /^((e(s|d)t|c(s|d)t|m(s|d)t|p(s|d)t)|((gmt)?\s*(\+|\-)\s*\d\d\d\d?)|gmt|utc)/i,
    ordinalSuffix: /^\s*(st|nd|rd|th)/i,
    timeContext: /^\s*(\:|a(?!u|p)|p)/i,
  },
  timezones: [
    { name: "UTC", offset: "-000" },
    { name: "GMT", offset: "-000" },
    { name: "EST", offset: "-0500" },
    { name: "EDT", offset: "-0400" },
    { name: "CST", offset: "-0600" },
    { name: "CDT", offset: "-0500" },
    { name: "MST", offset: "-0700" },
    { name: "MDT", offset: "-0600" },
    { name: "PST", offset: "-0800" },
    { name: "PDT", offset: "-0700" },
  ],
};
(function () {
  var $D = Date,
    $P = $D.prototype,
    $C = $D.CultureInfo,
    p = function (s, l) {
      if (!l) {
        l = 2;
      }
      return ("000" + s).slice(l * -1);
    };
  $P.clearTime = function () {
    this.setHours(0);
    this.setMinutes(0);
    this.setSeconds(0);
    this.setMilliseconds(0);
    return this;
  };
  $P.setTimeToNow = function () {
    var n = new Date();
    this.setHours(n.getHours());
    this.setMinutes(n.getMinutes());
    this.setSeconds(n.getSeconds());
    this.setMilliseconds(n.getMilliseconds());
    return this;
  };
  $D.today = function () {
    return new Date().clearTime();
  };
  $D.compare = function (date1, date2) {
    if (isNaN(date1) || isNaN(date2)) {
      throw new Error(date1 + " - " + date2);
    } else if (date1 instanceof Date && date2 instanceof Date) {
      return date1 < date2 ? -1 : date1 > date2 ? 1 : 0;
    } else {
      throw new TypeError(date1 + " - " + date2);
    }
  };
  $D.equals = function (date1, date2) {
    return date1.compareTo(date2) === 0;
  };
  $D.getDayNumberFromName = function (name) {
    var n = $C.dayNames,
      m = $C.abbreviatedDayNames,
      o = $C.shortestDayNames,
      s = name.toLowerCase();
    for (var i = 0; i < n.length; i++) {
      if (
        n[i].toLowerCase() == s ||
        m[i].toLowerCase() == s ||
        o[i].toLowerCase() == s
      ) {
        return i;
      }
    }
    return -1;
  };
  $D.getMonthNumberFromName = function (name) {
    var n = $C.monthNames,
      m = $C.abbreviatedMonthNames,
      s = name.toLowerCase();
    for (var i = 0; i < n.length; i++) {
      if (n[i].toLowerCase() == s || m[i].toLowerCase() == s) {
        return i;
      }
    }
    return -1;
  };
  $D.isLeapYear = function (year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
  };
  $D.getDaysInMonth = function (year, month) {
    return [
      31,
      $D.isLeapYear(year) ? 29 : 28,
      31,
      30,
      31,
      30,
      31,
      31,
      30,
      31,
      30,
      31,
    ][month];
  };
  $D.getTimezoneAbbreviation = function (offset) {
    var z = $C.timezones,
      p;
    for (var i = 0; i < z.length; i++) {
      if (z[i].offset === offset) {
        return z[i].name;
      }
    }
    return null;
  };
  $D.getTimezoneOffset = function (name) {
    var z = $C.timezones,
      p;
    for (var i = 0; i < z.length; i++) {
      if (z[i].name === name.toUpperCase()) {
        return z[i].offset;
      }
    }
    return null;
  };
  $P.clone = function () {
    return new Date(this.getTime());
  };
  $P.compareTo = function (date) {
    return Date.compare(this, date);
  };
  $P.equals = function (date) {
    return Date.equals(this, date || new Date());
  };
  $P.between = function (start, end) {
    return this.getTime() >= start.getTime() && this.getTime() <= end.getTime();
  };
  $P.isAfter = function (date) {
    return this.compareTo(date || new Date()) === 1;
  };
  $P.isBefore = function (date) {
    return this.compareTo(date || new Date()) === -1;
  };
  $P.isToday = function () {
    return this.isSameDay(new Date());
  };
  $P.isSameDay = function (date) {
    return this.clone().clearTime().equals(date.clone().clearTime());
  };
  $P.addMilliseconds = function (value) {
    this.setMilliseconds(this.getMilliseconds() + value);
    return this;
  };
  $P.addSeconds = function (value) {
    return this.addMilliseconds(value * 1000);
  };
  $P.addMinutes = function (value) {
    return this.addMilliseconds(value * 60000);
  };
  $P.addHours = function (value) {
    return this.addMilliseconds(value * 3600000);
  };
  $P.addDays = function (value) {
    this.setDate(this.getDate() + value);
    return this;
  };
  $P.addWeeks = function (value) {
    return this.addDays(value * 7);
  };
  $P.addMonths = function (value) {
    var n = this.getDate();
    this.setDate(1);
    this.setMonth(this.getMonth() + value);
    this.setDate(
      Math.min(n, $D.getDaysInMonth(this.getFullYear(), this.getMonth()))
    );
    return this;
  };
  $P.addYears = function (value) {
    return this.addMonths(value * 12);
  };
  $P.add = function (config) {
    if (typeof config == "number") {
      this._orient = config;
      return this;
    }
    var x = config;
    if (x.milliseconds) {
      this.addMilliseconds(x.milliseconds);
    }
    if (x.seconds) {
      this.addSeconds(x.seconds);
    }
    if (x.minutes) {
      this.addMinutes(x.minutes);
    }
    if (x.hours) {
      this.addHours(x.hours);
    }
    if (x.weeks) {
      this.addWeeks(x.weeks);
    }
    if (x.months) {
      this.addMonths(x.months);
    }
    if (x.years) {
      this.addYears(x.years);
    }
    if (x.days) {
      this.addDays(x.days);
    }
    return this;
  };
  var $y, $m, $d;
  $P.getWeek = function () {
    var a, b, c, d, e, f, g, n, s, w;
    $y = !$y ? this.getFullYear() : $y;
    $m = !$m ? this.getMonth() + 1 : $m;
    $d = !$d ? this.getDate() : $d;
    if ($m <= 2) {
      a = $y - 1;
      b = ((a / 4) | 0) - ((a / 100) | 0) + ((a / 400) | 0);
      c = (((a - 1) / 4) | 0) - (((a - 1) / 100) | 0) + (((a - 1) / 400) | 0);
      s = b - c;
      e = 0;
      f = $d - 1 + 31 * ($m - 1);
    } else {
      a = $y;
      b = ((a / 4) | 0) - ((a / 100) | 0) + ((a / 400) | 0);
      c = (((a - 1) / 4) | 0) - (((a - 1) / 100) | 0) + (((a - 1) / 400) | 0);
      s = b - c;
      e = s + 1;
      f = $d + (153 * ($m - 3) + 2) / 5 + 58 + s;
    }
    g = (a + b) % 7;
    d = (f + g - e) % 7;
    n = (f + 3 - d) | 0;
    if (n < 0) {
      w = 53 - (((g - s) / 5) | 0);
    } else if (n > 364 + s) {
      w = 1;
    } else {
      w = ((n / 7) | 0) + 1;
    }
    $y = $m = $d = null;
    return w;
  };
  $P.getISOWeek = function () {
    $y = this.getUTCFullYear();
    $m = this.getUTCMonth() + 1;
    $d = this.getUTCDate();
    return p(this.getWeek());
  };
  $P.setWeek = function (n) {
    return this.moveToDayOfWeek(1).addWeeks(n - this.getWeek());
  };
  $D._validate = function (n, min, max, name) {
    if (typeof n == "undefined") {
      return false;
    } else if (typeof n != "number") {
      throw new TypeError(n + " is not a Number.");
    } else if (n < min || n > max) {
      throw new RangeError(n + " is not a valid value for " + name + ".");
    }
    return true;
  };
  $D.validateMillisecond = function (value) {
    return $D._validate(value, 0, 999, "millisecond");
  };
  $D.validateSecond = function (value) {
    return $D._validate(value, 0, 59, "second");
  };
  $D.validateMinute = function (value) {
    return $D._validate(value, 0, 59, "minute");
  };
  $D.validateHour = function (value) {
    return $D._validate(value, 0, 23, "hour");
  };
  $D.validateDay = function (value, year, month) {
    return $D._validate(value, 1, $D.getDaysInMonth(year, month), "day");
  };
  $D.validateMonth = function (value) {
    return $D._validate(value, 0, 11, "month");
  };
  $D.validateYear = function (value) {
    return $D._validate(value, 0, 9999, "year");
  };
  $P.set = function (config) {
    if ($D.validateMillisecond(config.millisecond)) {
      this.addMilliseconds(config.millisecond - this.getMilliseconds());
    }
    if ($D.validateSecond(config.second)) {
      this.addSeconds(config.second - this.getSeconds());
    }
    if ($D.validateMinute(config.minute)) {
      this.addMinutes(config.minute - this.getMinutes());
    }
    if ($D.validateHour(config.hour)) {
      this.addHours(config.hour - this.getHours());
    }
    if ($D.validateMonth(config.month)) {
      this.addMonths(config.month - this.getMonth());
    }
    if ($D.validateYear(config.year)) {
      this.addYears(config.year - this.getFullYear());
    }
    if ($D.validateDay(config.day, this.getFullYear(), this.getMonth())) {
      this.addDays(config.day - this.getDate());
    }
    if (config.timezone) {
      this.setTimezone(config.timezone);
    }
    if (config.timezoneOffset) {
      this.setTimezoneOffset(config.timezoneOffset);
    }
    if (config.week && $D._validate(config.week, 0, 53, "week")) {
      this.setWeek(config.week);
    }
    return this;
  };
  $P.moveToFirstDayOfMonth = function () {
    return this.set({ day: 1 });
  };
  $P.moveToLastDayOfMonth = function () {
    return this.set({
      day: $D.getDaysInMonth(this.getFullYear(), this.getMonth()),
    });
  };
  $P.moveToNthOccurrence = function (dayOfWeek, occurrence) {
    var shift = 0;
    if (occurrence > 0) {
      shift = occurrence - 1;
    } else if (occurrence === -1) {
      this.moveToLastDayOfMonth();
      if (this.getDay() !== dayOfWeek) {
        this.moveToDayOfWeek(dayOfWeek, -1);
      }
      return this;
    }
    return this.moveToFirstDayOfMonth()
      .addDays(-1)
      .moveToDayOfWeek(dayOfWeek, +1)
      .addWeeks(shift);
  };
  $P.moveToDayOfWeek = function (dayOfWeek, orient) {
    var diff = (dayOfWeek - this.getDay() + 7 * (orient || +1)) % 7;
    return this.addDays(diff === 0 ? (diff += 7 * (orient || +1)) : diff);
  };
  $P.moveToMonth = function (month, orient) {
    var diff = (month - this.getMonth() + 12 * (orient || +1)) % 12;
    return this.addMonths(diff === 0 ? (diff += 12 * (orient || +1)) : diff);
  };
  $P.getOrdinalNumber = function () {
    return (
      Math.ceil(
        (this.clone().clearTime() - new Date(this.getFullYear(), 0, 1)) /
          86400000
      ) + 1
    );
  };
  $P.getTimezone = function () {
    return $D.getTimezoneAbbreviation(this.getUTCOffset());
  };
  $P.setTimezoneOffset = function (offset) {
    var here = this.getTimezoneOffset(),
      there = (Number(offset) * -6) / 10;
    return this.addMinutes(there - here);
  };
  $P.setTimezone = function (offset) {
    return this.setTimezoneOffset($D.getTimezoneOffset(offset));
  };
  $P.hasDaylightSavingTime = function () {
    return (
      Date.today().set({ month: 0, day: 1 }).getTimezoneOffset() !==
      Date.today().set({ month: 6, day: 1 }).getTimezoneOffset()
    );
  };
  $P.isDaylightSavingTime = function () {
    return (
      this.hasDaylightSavingTime() &&
      new Date().getTimezoneOffset() ===
        Date.today().set({ month: 6, day: 1 }).getTimezoneOffset()
    );
  };
  $P.getUTCOffset = function () {
    var n = (this.getTimezoneOffset() * -10) / 6,
      r;
    if (n < 0) {
      r = (n - 10000).toString();
      return r.charAt(0) + r.substr(2);
    } else {
      r = (n + 10000).toString();
      return "+" + r.substr(1);
    }
  };
  $P.getElapsed = function (date) {
    return (date || new Date()) - this;
  };
  if (!$P.toISOString) {
    $P.toISOString = function () {
      function f(n) {
        return n < 10 ? "0" + n : n;
      }
      return (
        '"' +
        this.getUTCFullYear() +
        "-" +
        f(this.getUTCMonth() + 1) +
        "-" +
        f(this.getUTCDate()) +
        "T" +
        f(this.getUTCHours()) +
        ":" +
        f(this.getUTCMinutes()) +
        ":" +
        f(this.getUTCSeconds()) +
        'Z"'
      );
    };
  }
  $P._toString = $P.toString;
  $P.toString = function (format) {
    var x = this;
    if (format && format.length == 1) {
      var c = $C.formatPatterns;
      x.t = x.toString;
      switch (format) {
        case "d":
          return x.t(c.shortDate);
        case "D":
          return x.t(c.longDate);
        case "F":
          return x.t(c.fullDateTime);
        case "m":
          return x.t(c.monthDay);
        case "r":
          return x.t(c.rfc1123);
        case "s":
          return x.t(c.sortableDateTime);
        case "t":
          return x.t(c.shortTime);
        case "T":
          return x.t(c.longTime);
        case "u":
          return x.t(c.universalSortableDateTime);
        case "y":
          return x.t(c.yearMonth);
      }
    }
    var ord = function (n) {
      switch (n * 1) {
        case 1:
        case 21:
        case 31:
          return "st";
        case 2:
        case 22:
          return "nd";
        case 3:
        case 23:
          return "rd";
        default:
          return "th";
      }
    };
    return format
      ? format.replace(
          /(\\)?(dd?d?d?|MM?M?M?|yy?y?y?|hh?|HH?|mm?|ss?|tt?|S)/g,
          function (m) {
            if (m.charAt(0) === "\\") {
              return m.replace("\\", "");
            }
            x.h = x.getHours;
            switch (m) {
              case "hh":
                return p(x.h() < 13 ? (x.h() === 0 ? 12 : x.h()) : x.h() - 12);
              case "h":
                return x.h() < 13 ? (x.h() === 0 ? 12 : x.h()) : x.h() - 12;
              case "HH":
                return p(x.h());
              case "H":
                return x.h();
              case "mm":
                return p(x.getMinutes());
              case "m":
                return x.getMinutes();
              case "ss":
                return p(x.getSeconds());
              case "s":
                return x.getSeconds();
              case "yyyy":
                return p(x.getFullYear(), 4);
              case "yy":
                return p(x.getFullYear());
              case "dddd":
                return $C.dayNames[x.getDay()];
              case "ddd":
                return $C.abbreviatedDayNames[x.getDay()];
              case "dd":
                return p(x.getDate());
              case "d":
                return x.getDate();
              case "MMMM":
                return $C.monthNames[x.getMonth()];
              case "MMM":
                return $C.abbreviatedMonthNames[x.getMonth()];
              case "MM":
                return p(x.getMonth() + 1);
              case "M":
                return x.getMonth() + 1;
              case "t":
                return x.h() < 12
                  ? $C.amDesignator.substring(0, 1)
                  : $C.pmDesignator.substring(0, 1);
              case "tt":
                return x.h() < 12 ? $C.amDesignator : $C.pmDesignator;
              case "S":
                return ord(x.getDate());
              default:
                return m;
            }
          }
        )
      : this._toString();
  };
})();

/* Rebuy: muestra el precio directamente en el CTA del widget de rutina. */
(() => {
  const widgetSelector = '#rebuy-widget-143474';

  const updateRoutineButtons = () => {
    const widget = document.querySelector(widgetSelector);
    if (!widget) return;

    widget.querySelectorAll('.rebuy-product-block').forEach((product) => {
      const button = product.querySelector('.rebuy-product-actions .rebuy-button, .rebuy-product-actions button');
      const price = product.querySelector('.rebuy-product-price .rebuy-money, .rebuy-product-price');

      if (!button || !price) return;

      const rawPriceText = price.textContent.replace(/\s+/g, ' ').trim();
      const priceMatch = rawPriceText.match(/[\d.,\s]+\s*(?:€|EUR)/i);
      const priceText = priceMatch ? priceMatch[0].trim() : rawPriceText.replace(/^price\s*/i, '');
      const buttonText = `Añadir por ${priceText}`;

      if (priceText && button.textContent.trim() !== buttonText) {
        button.textContent = buttonText;
      }
    });
  };

  const observeRoutineWidget = () => {
    const widget = document.querySelector(widgetSelector);
    if (!widget || widget.dataset.routineButtonObserver === 'true') return;

    widget.dataset.routineButtonObserver = 'true';
    updateRoutineButtons();

    new MutationObserver(updateRoutineButtons).observe(widget, {
      childList: true,
      subtree: true
    });
  };

  const initialise = () => {
    observeRoutineWidget();
    updateRoutineButtons();
  };

  document.addEventListener('DOMContentLoaded', initialise);
  document.addEventListener('rebuy.init', () => setTimeout(initialise, 0));
  window.addEventListener('load', initialise);
})();
(function () {
  var $D = Date,
    $P = $D.prototype,
    $C = $D.CultureInfo,
    $N = Number.prototype;
  $P._orient = +1;
  $P._nth = null;
  $P._is = false;
  $P._same = false;
  $P._isSecond = false;
  $N._dateElement = "day";
  $P.next = function () {
    this._orient = +1;
    return this;
  };
  $D.next = function () {
    return $D.today().next();
  };
  $P.last =
    $P.prev =
    $P.previous =
      function () {
        this._orient = -1;
        return this;
      };
  $D.last =
    $D.prev =
    $D.previous =
      function () {
        return $D.today().last();
      };
  $P.is = function () {
    this._is = true;
    return this;
  };
  $P.same = function () {
    this._same = true;
    this._isSecond = false;
    return this;
  };
  $P.today = function () {
    return this.same().day();
  };
  $P.weekday = function () {
    if (this._is) {
      this._is = false;
      return !this.is().sat() && !this.is().sun();
    }
    return false;
  };
  $P.at = function (time) {
    return typeof time === "string"
      ? $D.parse(this.toString("d") + " " + time)
      : this.set(time);
  };
  $N.fromNow = $N.after = function (date) {
    var c = {};
    c[this._dateElement] = this;
    return (!date ? new Date() : date.clone()).add(c);
  };
  $N.ago = $N.before = function (date) {
    var c = {};
    c[this._dateElement] = this * -1;
    return (!date ? new Date() : date.clone()).add(c);
  };
  var dx = "sunday monday tuesday wednesday thursday friday saturday".split(
      /\s/
    ),
    mx =
      "january february march april may june july august september october november december".split(
        /\s/
      ),
    px = "Millisecond Second Minute Hour Day Week Month Year".split(/\s/),
    pxf = "Milliseconds Seconds Minutes Hours Date Week Month FullYear".split(
      /\s/
    ),
    nth = "final first second third fourth fifth".split(/\s/),
    de;
  $P.toObject = function () {
    var o = {};
    for (var i = 0; i < px.length; i++) {
      o[px[i].toLowerCase()] = this["get" + pxf[i]]();
    }
    return o;
  };
  $D.fromObject = function (config) {
    config.week = null;
    return Date.today().set(config);
  };
  var df = function (n) {
    return function () {
      if (this._is) {
        this._is = false;
        return this.getDay() == n;
      }
      if (this._nth !== null) {
        if (this._isSecond) {
          this.addSeconds(this._orient * -1);
        }
        this._isSecond = false;
        var ntemp = this._nth;
        this._nth = null;
        var temp = this.clone().moveToLastDayOfMonth();
        this.moveToNthOccurrence(n, ntemp);
        if (this > temp) {
          throw new RangeError(
            $D.getDayName(n) +
              " does not occur " +
              ntemp +
              " times in the month of " +
              $D.getMonthName(temp.getMonth()) +
              " " +
              temp.getFullYear() +
              "."
          );
        }
        return this;
      }
      return this.moveToDayOfWeek(n, this._orient);
    };
  };
  var sdf = function (n) {
    return function () {
      var t = $D.today(),
        shift = n - t.getDay();
      if (n === 0 && $C.firstDayOfWeek === 1 && t.getDay() !== 0) {
        shift = shift + 7;
      }
      return t.addDays(shift);
    };
  };
  for (var i = 0; i < dx.length; i++) {
    $D[dx[i].toUpperCase()] = $D[dx[i].toUpperCase().substring(0, 3)] = i;
    $D[dx[i]] = $D[dx[i].substring(0, 3)] = sdf(i);
    $P[dx[i]] = $P[dx[i].substring(0, 3)] = df(i);
  }
  var mf = function (n) {
    return function () {
      if (this._is) {
        this._is = false;
        return this.getMonth() === n;
      }
      return this.moveToMonth(n, this._orient);
    };
  };
  var smf = function (n) {
    return function () {
      return $D.today().set({ month: n, day: 1 });
    };
  };
  for (var j = 0; j < mx.length; j++) {
    $D[mx[j].toUpperCase()] = $D[mx[j].toUpperCase().substring(0, 3)] = j;
    $D[mx[j]] = $D[mx[j].substring(0, 3)] = smf(j);
    $P[mx[j]] = $P[mx[j].substring(0, 3)] = mf(j);
  }
  var ef = function (j) {
    return function () {
      if (this._isSecond) {
        this._isSecond = false;
        return this;
      }
      if (this._same) {
        this._same = this._is = false;
        var o1 = this.toObject(),
          o2 = (arguments[0] || new Date()).toObject(),
          v = "",
          k = j.toLowerCase();
        for (var m = px.length - 1; m > -1; m--) {
          v = px[m].toLowerCase();
          if (o1[v] != o2[v]) {
            return false;
          }
          if (k == v) {
            break;
          }
        }
        return true;
      }
      if (j.substring(j.length - 1) != "s") {
        j += "s";
      }
      return this["add" + j](this._orient);
    };
  };
  var nf = function (n) {
    return function () {
      this._dateElement = n;
      return this;
    };
  };
  for (var k = 0; k < px.length; k++) {
    de = px[k].toLowerCase();
    $P[de] = $P[de + "s"] = ef(px[k]);
    $N[de] = $N[de + "s"] = nf(de);
  }
  $P._ss = ef("Second");
  var nthfn = function (n) {
    return function (dayOfWeek) {
      if (this._same) {
        return this._ss(arguments[0]);
      }
      if (dayOfWeek || dayOfWeek === 0) {
        return this.moveToNthOccurrence(dayOfWeek, n);
      }
      this._nth = n;
      if (n === 2 && (dayOfWeek === undefined || dayOfWeek === null)) {
        this._isSecond = true;
        return this.addSeconds(this._orient);
      }
      return this;
    };
  };
  for (var l = 0; l < nth.length; l++) {
    $P[nth[l]] = l === 0 ? nthfn(-1) : nthfn(l);
  }
})();
(function () {
  Date.Parsing = {
    Exception: function (s) {
      this.message = "Parse error at '" + s.substring(0, 10) + " ...'";
    },
  };
  var $P = Date.Parsing;
  var _ = ($P.Operators = {
    rtoken: function (r) {
      return function (s) {
        var mx = s.match(r);
        if (mx) {
          return [mx[0], s.substring(mx[0].length)];
        } else {
          throw new $P.Exception(s);
        }
      };
    },
    token: function (s) {
      return function (s) {
        return _.rtoken(new RegExp("^s*" + s + "s*"))(s);
      };
    },
    stoken: function (s) {
      return _.rtoken(new RegExp("^" + s));
    },
    until: function (p) {
      return function (s) {
        var qx = [],
          rx = null;
        while (s.length) {
          try {
            rx = p.call(this, s);
          } catch (e) {
            qx.push(rx[0]);
            s = rx[1];
            continue;
          }
          break;
        }
        return [qx, s];
      };
    },
    many: function (p) {
      return function (s) {
        var rx = [],
          r = null;
        while (s.length) {
          try {
            r = p.call(this, s);
          } catch (e) {
            return [rx, s];
          }
          rx.push(r[0]);
          s = r[1];
        }
        return [rx, s];
      };
    },
    optional: function (p) {
      return function (s) {
        var r = null;
        try {
          r = p.call(this, s);
        } catch (e) {
          return [null, s];
        }
        return [r[0], r[1]];
      };
    },
    not: function (p) {
      return function (s) {
        try {
          p.call(this, s);
        } catch (e) {
          return [null, s];
        }
        throw new $P.Exception(s);
      };
    },
    ignore: function (p) {
      return p
        ? function (s) {
            var r = null;
            r = p.call(this, s);
            return [null, r[1]];
          }
        : null;
    },
    product: function () {
      var px = arguments[0],
        qx = Array.prototype.slice.call(arguments, 1),
        rx = [];
      for (var i = 0; i < px.length; i++) {
        rx.push(_.each(px[i], qx));
      }
      return rx;
    },
    cache: function (rule) {
      var cache = {},
        r = null;
      return function (s) {
        try {
          r = cache[s] = cache[s] || rule.call(this, s);
        } catch (e) {
          r = cache[s] = e;
        }
        if (r instanceof $P.Exception) {
          throw r;
        } else {
          return r;
        }
      };
    },
    any: function () {
      var px = arguments;
      return function (s) {
        var r = null;
        for (var i = 0; i < px.length; i++) {
          if (px[i] == null) {
            continue;
          }
          try {
            r = px[i].call(this, s);
          } catch (e) {
            r = null;
          }
          if (r) {
            return r;
          }
        }
        throw new $P.Exception(s);
      };
    },
    each: function () {
      var px = arguments;
      return function (s) {
        var rx = [],
          r = null;
        for (var i = 0; i < px.length; i++) {
          if (px[i] == null) {
            continue;
          }
          try {
            r = px[i].call(this, s);
          } catch (e) {
            throw new $P.Exception(s);
          }
          rx.push(r[0]);
          s = r[1];
        }
        return [rx, s];
      };
    },
    all: function () {
      var px = arguments,
        _ = _;
      return _.each(_.optional(px));
    },
    sequence: function (px, d, c) {
      d = d || _.rtoken(/^\s*/);
      c = c || null;
      if (px.length == 1) {
        return px[0];
      }
      return function (s) {
        var r = null,
          q = null;
        var rx = [];
        for (var i = 0; i < px.length; i++) {
          try {
            r = px[i].call(this, s);
          } catch (e) {
            break;
          }
          rx.push(r[0]);
          try {
            q = d.call(this, r[1]);
          } catch (ex) {
            q = null;
            break;
          }
          s = q[1];
        }
        if (!r) {
          throw new $P.Exception(s);
        }
        if (q) {
          throw new $P.Exception(q[1]);
        }
        if (c) {
          try {
            r = c.call(this, r[1]);
          } catch (ey) {
            throw new $P.Exception(r[1]);
          }
        }
        return [rx, r ? r[1] : s];
      };
    },
    between: function (d1, p, d2) {
      d2 = d2 || d1;
      var _fn = _.each(_.ignore(d1), p, _.ignore(d2));
      return function (s) {
        var rx = _fn.call(this, s);
        return [[rx[0][0], r[0][2]], rx[1]];
      };
    },
    list: function (p, d, c) {
      d = d || _.rtoken(/^\s*/);
      c = c || null;
      return p instanceof Array
        ? _.each(
            _.product(p.slice(0, -1), _.ignore(d)),
            p.slice(-1),
            _.ignore(c)
          )
        : _.each(_.many(_.each(p, _.ignore(d))), px, _.ignore(c));
    },
    set: function (px, d, c) {
      d = d || _.rtoken(/^\s*/);
      c = c || null;
      return function (s) {
        var r = null,
          p = null,
          q = null,
          rx = null,
          best = [[], s],
          last = false;
        for (var i = 0; i < px.length; i++) {
          q = null;
          p = null;
          r = null;
          last = px.length == 1;
          try {
            r = px[i].call(this, s);
          } catch (e) {
            continue;
          }
          rx = [[r[0]], r[1]];
          if (r[1].length > 0 && !last) {
            try {
              q = d.call(this, r[1]);
            } catch (ex) {
              last = true;
            }
          } else {
            last = true;
          }
          if (!last && q[1].length === 0) {
            last = true;
          }
          if (!last) {
            var qx = [];
            for (var j = 0; j < px.length; j++) {
              if (i != j) {
                qx.push(px[j]);
              }
            }
            p = _.set(qx, d).call(this, q[1]);
            if (p[0].length > 0) {
              rx[0] = rx[0].concat(p[0]);
              rx[1] = p[1];
            }
          }
          if (rx[1].length < best[1].length) {
            best = rx;
          }
          if (best[1].length === 0) {
            break;
          }
        }
        if (best[0].length === 0) {
          return best;
        }
        if (c) {
          try {
            q = c.call(this, best[1]);
          } catch (ey) {
            throw new $P.Exception(best[1]);
          }
          best[1] = q[1];
        }
        return best;
      };
    },
    forward: function (gr, fname) {
      return function (s) {
        return gr[fname].call(this, s);
      };
    },
    replace: function (rule, repl) {
      return function (s) {
        var r = rule.call(this, s);
        return [repl, r[1]];
      };
    },
    process: function (rule, fn) {
      return function (s) {
        var r = rule.call(this, s);
        return [fn.call(this, r[0]), r[1]];
      };
    },
    min: function (min, rule) {
      return function (s) {
        var rx = rule.call(this, s);
        if (rx[0].length < min) {
          throw new $P.Exception(s);
        }
        return rx;
      };
    },
  });
  var _generator = function (op) {
    return function () {
      var args = null,
        rx = [];
      if (arguments.length > 1) {
        args = Array.prototype.slice.call(arguments);
      } else if (arguments[0] instanceof Array) {
        args = arguments[0];
      }
      if (args) {
        for (var i = 0, px = args.shift(); i < px.length; i++) {
          args.unshift(px[i]);
          rx.push(op.apply(null, args));
          args.shift();
          return rx;
        }
      } else {
        return op.apply(null, arguments);
      }
    };
  };
  var gx = "optional not ignore cache".split(/\s/);
  for (var i = 0; i < gx.length; i++) {
    _[gx[i]] = _generator(_[gx[i]]);
  }
  var _vector = function (op) {
    return function () {
      if (arguments[0] instanceof Array) {
        return op.apply(null, arguments[0]);
      } else {
        return op.apply(null, arguments);
      }
    };
  };
  var vx = "each any all".split(/\s/);
  for (var j = 0; j < vx.length; j++) {
    _[vx[j]] = _vector(_[vx[j]]);
  }
})();
(function () {
  var $D = Date,
    $P = $D.prototype,
    $C = $D.CultureInfo;
  var flattenAndCompact = function (ax) {
    var rx = [];
    for (var i = 0; i < ax.length; i++) {
      if (ax[i] instanceof Array) {
        rx = rx.concat(flattenAndCompact(ax[i]));
      } else {
        if (ax[i]) {
          rx.push(ax[i]);
        }
      }
    }
    return rx;
  };
  $D.Grammar = {};
  $D.Translator = {
    hour: function (s) {
      return function () {
        this.hour = Number(s);
      };
    },
    minute: function (s) {
      return function () {
        this.minute = Number(s);
      };
    },
    second: function (s) {
      return function () {
        this.second = Number(s);
      };
    },
    meridian: function (s) {
      return function () {
        this.meridian = s.slice(0, 1).toLowerCase();
      };
    },
    timezone: function (s) {
      return function () {
        var n = s.replace(/[^\d\+\-]/g, "");
        if (n.length) {
          this.timezoneOffset = Number(n);
        } else {
          this.timezone = s.toLowerCase();
        }
      };
    },
    day: function (x) {
      var s = x[0];
      return function () {
        this.day = Number(s.match(/\d+/)[0]);
      };
    },
    month: function (s) {
      return function () {
        this.month =
          s.length == 3
            ? "jan feb mar apr may jun jul aug sep oct nov dec".indexOf(s) / 4
            : Number(s) - 1;
      };
    },
    year: function (s) {
      return function () {
        var n = Number(s);
        this.year =
          s.length > 2 ? n : n + (n + 2000 < $C.twoDigitYearMax ? 2000 : 1900);
      };
    },
    rday: function (s) {
      return function () {
        switch (s) {
          case "yesterday":
            this.days = -1;
            break;
          case "tomorrow":
            this.days = 1;
            break;
          case "today":
            this.days = 0;
            break;
          case "now":
            this.days = 0;
            this.now = true;
            break;
        }
      };
    },
    finishExact: function (x) {
      x = x instanceof Array ? x : [x];
      for (var i = 0; i < x.length; i++) {
        if (x[i]) {
          x[i].call(this);
        }
      }
      var now = new Date();
      if (
        (this.hour || this.minute) &&
        !this.month &&
        !this.year &&
        !this.day
      ) {
        this.day = now.getDate();
      }
      if (!this.year) {
        this.year = now.getFullYear();
      }
      if (!this.month && this.month !== 0) {
        this.month = now.getMonth();
      }
      if (!this.day) {
        this.day = 1;
      }
      if (!this.hour) {
        this.hour = 0;
      }
      if (!this.minute) {
        this.minute = 0;
      }
      if (!this.second) {
        this.second = 0;
      }
      if (this.meridian && this.hour) {
        if (this.meridian == "p" && this.hour < 12) {
          this.hour = this.hour + 12;
        } else if (this.meridian == "a" && this.hour == 12) {
          this.hour = 0;
        }
      }
      if (this.day > $D.getDaysInMonth(this.year, this.month)) {
        throw new RangeError(this.day + " is not a valid value for days.");
      }
      var r = new Date(
        this.year,
        this.month,
        this.day,
        this.hour,
        this.minute,
        this.second
      );
      if (this.timezone) {
        r.set({ timezone: this.timezone });
      } else if (this.timezoneOffset) {
        r.set({ timezoneOffset: this.timezoneOffset });
      }
      return r;
    },
    finish: function (x) {
      x = x instanceof Array ? flattenAndCompact(x) : [x];
      if (x.length === 0) {
        return null;
      }
      for (var i = 0; i < x.length; i++) {
        if (typeof x[i] == "function") {
          x[i].call(this);
        }
      }
      var today = $D.today();
      if (this.now && !this.unit && !this.operator) {
        return new Date();
      } else if (this.now) {
        today = new Date();
      }
      var expression = !!(
        (this.days && this.days !== null) ||
        this.orient ||
        this.operator
      );
      var gap, mod, orient;
      orient = this.orient == "past" || this.operator == "subtract" ? -1 : 1;
      if (!this.now && "hour minute second".indexOf(this.unit) != -1) {
        today.setTimeToNow();
      }
      if (this.month || this.month === 0) {
        if ("year day hour minute second".indexOf(this.unit) != -1) {
          this.value = this.month + 1;
          this.month = null;
          expression = true;
        }
      }
      if (!expression && this.weekday && !this.day && !this.days) {
        var temp = Date[this.weekday]();
        this.day = temp.getDate();
        if (!this.month) {
          this.month = temp.getMonth();
        }
        this.year = temp.getFullYear();
      }
      if (expression && this.weekday && this.unit != "month") {
        this.unit = "day";
        gap = $D.getDayNumberFromName(this.weekday) - today.getDay();
        mod = 7;
        this.days = gap ? (gap + orient * mod) % mod : orient * mod;
      }
      if (this.month && this.unit == "day" && this.operator) {
        this.value = this.month + 1;
        this.month = null;
      }
      if (this.value != null && this.month != null && this.year != null) {
        this.day = this.value * 1;
      }
      if (this.month && !this.day && this.value) {
        today.set({ day: this.value * 1 });
        if (!expression) {
          this.day = this.value * 1;
        }
      }
      if (!this.month && this.value && this.unit == "month" && !this.now) {
        this.month = this.value;
        expression = true;
      }
      if (
        expression &&
        (this.month || this.month === 0) &&
        this.unit != "year"
      ) {
        this.unit = "month";
        gap = this.month - today.getMonth();
        mod = 12;
        this.months = gap ? (gap + orient * mod) % mod : orient * mod;
        this.month = null;
      }
      if (!this.unit) {
        this.unit = "day";
      }
      if (
        !this.value &&
        this.operator &&
        this.operator !== null &&
        this[this.unit + "s"] &&
        this[this.unit + "s"] !== null
      ) {
        this[this.unit + "s"] =
          this[this.unit + "s"] +
          (this.operator == "add" ? 1 : -1) +
          (this.value || 0) * orient;
      } else if (this[this.unit + "s"] == null || this.operator != null) {
        if (!this.value) {
          this.value = 1;
        }
        this[this.unit + "s"] = this.value * orient;
      }
      if (this.meridian && this.hour) {
        if (this.meridian == "p" && this.hour < 12) {
          this.hour = this.hour + 12;
        } else if (this.meridian == "a" && this.hour == 12) {
          this.hour = 0;
        }
      }
      if (this.weekday && !this.day && !this.days) {
        var temp = Date[this.weekday]();
        this.day = temp.getDate();
        if (temp.getMonth() !== today.getMonth()) {
          this.month = temp.getMonth();
        }
      }
      if ((this.month || this.month === 0) && !this.day) {
        this.day = 1;
      }
      if (
        !this.orient &&
        !this.operator &&
        this.unit == "week" &&
        this.value &&
        !this.day &&
        !this.month
      ) {
        return Date.today().setWeek(this.value);
      }
      if (expression && this.timezone && this.day && this.days) {
        this.day = this.days;
      }
      return expression ? today.add(this) : today.set(this);
    },
  };
  var _ = $D.Parsing.Operators,
    g = $D.Grammar,
    t = $D.Translator,
    _fn;
  g.datePartDelimiter = _.rtoken(/^([\s\-\.\,\/\x27]+)/);
  g.timePartDelimiter = _.stoken(":");
  g.whiteSpace = _.rtoken(/^\s*/);
  g.generalDelimiter = _.rtoken(/^(([\s\,]|at|@|on)+)/);
  var _C = {};
  g.ctoken = function (keys) {
    var fn = _C[keys];
    if (!fn) {
      var c = $C.regexPatterns;
      var kx = keys.split(/\s+/),
        px = [];
      for (var i = 0; i < kx.length; i++) {
        px.push(_.replace(_.rtoken(c[kx[i]]), kx[i]));
      }
      fn = _C[keys] = _.any.apply(null, px);
    }
    return fn;
  };
  g.ctoken2 = function (key) {
    return _.rtoken($C.regexPatterns[key]);
  };
  g.h = _.cache(_.process(_.rtoken(/^(0[0-9]|1[0-2]|[1-9])/), t.hour));
  g.hh = _.cache(_.process(_.rtoken(/^(0[0-9]|1[0-2])/), t.hour));
  g.H = _.cache(_.process(_.rtoken(/^([0-1][0-9]|2[0-3]|[0-9])/), t.hour));
  g.HH = _.cache(_.process(_.rtoken(/^([0-1][0-9]|2[0-3])/), t.hour));
  g.m = _.cache(_.process(_.rtoken(/^([0-5][0-9]|[0-9])/), t.minute));
  g.mm = _.cache(_.process(_.rtoken(/^[0-5][0-9]/), t.minute));
  g.s = _.cache(_.process(_.rtoken(/^([0-5][0-9]|[0-9])/), t.second));
  g.ss = _.cache(_.process(_.rtoken(/^[0-5][0-9]/), t.second));
  g.hms = _.cache(_.sequence([g.H, g.m, g.s], g.timePartDelimiter));
  g.t = _.cache(_.process(g.ctoken2("shortMeridian"), t.meridian));
  g.tt = _.cache(_.process(g.ctoken2("longMeridian"), t.meridian));
  g.z = _.cache(
    _.process(
      _.rtoken(/^((\+|\-)\s*\d\d\d\d)|((\+|\-)\d\d\:?\d\d)/),
      t.timezone
    )
  );
  g.zz = _.cache(
    _.process(
      _.rtoken(/^((\+|\-)\s*\d\d\d\d)|((\+|\-)\d\d\:?\d\d)/),
      t.timezone
    )
  );
  g.zzz = _.cache(_.process(g.ctoken2("timezone"), t.timezone));
  g.timeSuffix = _.each(_.ignore(g.whiteSpace), _.set([g.tt, g.zzz]));
  g.time = _.each(_.optional(_.ignore(_.stoken("T"))), g.hms, g.timeSuffix);
  g.d = _.cache(
    _.process(
      _.each(
        _.rtoken(/^([0-2]\d|3[0-1]|\d)/),
        _.optional(g.ctoken2("ordinalSuffix"))
      ),
      t.day
    )
  );
  g.dd = _.cache(
    _.process(
      _.each(
        _.rtoken(/^([0-2]\d|3[0-1])/),
        _.optional(g.ctoken2("ordinalSuffix"))
      ),
      t.day
    )
  );
  g.ddd = g.dddd = _.cache(
    _.process(g.ctoken("sun mon tue wed thu fri sat"), function (s) {
      return function () {
        this.weekday = s;
      };
    })
  );
  g.M = _.cache(_.process(_.rtoken(/^(1[0-2]|0\d|\d)/), t.month));
  g.MM = _.cache(_.process(_.rtoken(/^(1[0-2]|0\d)/), t.month));
  g.MMM = g.MMMM = _.cache(
    _.process(
      g.ctoken("jan feb mar apr may jun jul aug sep oct nov dec"),
      t.month
    )
  );
  g.y = _.cache(_.process(_.rtoken(/^(\d\d?)/), t.year));
  g.yy = _.cache(_.process(_.rtoken(/^(\d\d)/), t.year));
  g.yyy = _.cache(_.process(_.rtoken(/^(\d\d?\d?\d?)/), t.year));
  g.yyyy = _.cache(_.process(_.rtoken(/^(\d\d\d\d)/), t.year));
  _fn = function () {
    return _.each(
      _.any.apply(null, arguments),
      _.not(g.ctoken2("timeContext"))
    );
  };
  g.day = _fn(g.d, g.dd);
  g.month = _fn(g.M, g.MMM);
  g.year = _fn(g.yyyy, g.yy);
  g.orientation = _.process(g.ctoken("past future"), function (s) {
    return function () {
      this.orient = s;
    };
  });
  g.operator = _.process(g.ctoken("add subtract"), function (s) {
    return function () {
      this.operator = s;
    };
  });
  g.rday = _.process(g.ctoken("yesterday tomorrow today now"), t.rday);
  g.unit = _.process(
    g.ctoken("second minute hour day week month year"),
    function (s) {
      return function () {
        this.unit = s;
      };
    }
  );
  g.value = _.process(_.rtoken(/^\d\d?(st|nd|rd|th)?/), function (s) {
    return function () {
      this.value = s.replace(/\D/g, "");
    };
  });
  g.expression = _.set([
    g.rday,
    g.operator,
    g.value,
    g.unit,
    g.orientation,
    g.ddd,
    g.MMM,
  ]);
  _fn = function () {
    return _.set(arguments, g.datePartDelimiter);
  };
  g.mdy = _fn(g.ddd, g.month, g.day, g.year);
  g.ymd = _fn(g.ddd, g.year, g.month, g.day);
  g.dmy = _fn(g.ddd, g.day, g.month, g.year);
  g.date = function (s) {
    return (g[$C.dateElementOrder] || g.mdy).call(this, s);
  };
  g.format = _.process(
    _.many(
      _.any(
        _.process(
          _.rtoken(/^(dd?d?d?|MM?M?M?|yy?y?y?|hh?|HH?|mm?|ss?|tt?|zz?z?)/),
          function (fmt) {
            if (g[fmt]) {
              return g[fmt];
            } else {
              throw $D.Parsing.Exception(fmt);
            }
          }
        ),
        _.process(_.rtoken(/^[^dMyhHmstz]+/), function (s) {
          return _.ignore(_.stoken(s));
        })
      )
    ),
    function (rules) {
      return _.process(_.each.apply(null, rules), t.finishExact);
    }
  );
  var _F = {};
  var _get = function (f) {
    return (_F[f] = _F[f] || g.format(f)[0]);
  };
  g.formats = function (fx) {
    if (fx instanceof Array) {
      var rx = [];
      for (var i = 0; i < fx.length; i++) {
        rx.push(_get(fx[i]));
      }
      return _.any.apply(null, rx);
    } else {
      return _get(fx);
    }
  };
  g._formats = g.formats([
    '"yyyy-MM-ddTHH:mm:ssZ"',
    "yyyy-MM-ddTHH:mm:ssZ",
    "yyyy-MM-ddTHH:mm:ssz",
    "yyyy-MM-ddTHH:mm:ss",
    "yyyy-MM-ddTHH:mmZ",
    "yyyy-MM-ddTHH:mmz",
    "yyyy-MM-ddTHH:mm",
    "ddd, MMM dd, yyyy H:mm:ss tt",
    "ddd MMM d yyyy HH:mm:ss zzz",
    "MMddyyyy",
    "ddMMyyyy",
    "Mddyyyy",
    "ddMyyyy",
    "Mdyyyy",
    "dMyyyy",
    "yyyy",
    "Mdyy",
    "dMyy",
    "d",
  ]);
  g._start = _.process(
    _.set([g.date, g.time, g.expression], g.generalDelimiter, g.whiteSpace),
    t.finish
  );
  g.start = function (s) {
    try {
      var r = g._formats.call({}, s);
      if (r[1].length === 0) {
        return r;
      }
    } catch (e) {}
    return g._start.call({}, s);
  };
  $D._parse = $D.parse;
  $D.parse = function (s) {
    var r = null;
    if (!s) {
      return null;
    }
    if (s instanceof Date) {
      return s;
    }
    try {
      r = $D.Grammar.start.call({}, s.replace(/^\s*(\S*(\s+\S+)*)\s*$/, "$1"));
    } catch (e) {
      return null;
    }
    return r[1].length === 0 ? r[0] : null;
  };
  $D.getParseFunction = function (fx) {
    var fn = $D.Grammar.formats(fx);
    return function (s) {
      var r = null;
      try {
        r = fn.call({}, s);
      } catch (e) {
        return null;
      }
      return r[1].length === 0 ? r[0] : null;
    };
  };
  $D.parseExact = function (s, fx) {
    return $D.getParseFunction(fx)(s);
  };
})();

$(document).ready(function () {
  // Fixed bar

  $(".fixed__button").on("click touch", function (e) {
    e.preventDefault();
    $('.ProductForm__AddToCart:not([data-popup-trigger])').first().trigger("click");
    $(this).prop("disabled", true);

    document.addEventListener("product:added", function (event) {
      $(this).prop("disabled", false);
    });
  });

  $(".ingredients__slide-products").flickity({
    prevNextButtons: false,
  });

  // Shipping date

  // if($('.template-product').length) {
  //     const d = new Date();
  //     let hour = d.getHours();

  //     if(hour < 16) {
  //         $('.buy__date').show();
  //     }
  // }

  if ($("#fromDate").length > 0) {
    const d = new Date();
    let hour = parseInt(d.getHours());

    var today = Date.today();
    // var fromDate = Date.today().addDays(5);

    var lastDate;

    if (today.is().monday() || today.is().tuesday() || today.is().wednesday()) {
      if (hour <= 14) {
        lastDate = Date.today().addDays(1);
        document.getElementById("delivery-tomorrow").style.display = "inline";
        document.getElementById("delivery-el").style.display = "none";
        document.getElementById("fromDate").style.display = "none";
      } else {
        lastDate = Date.today().addDays(2);
      }
    }

    if (today.is().thursday()) {
      if (hour <= 14) {
        lastDate = Date.today().addDays(1);
        document.getElementById("delivery-tomorrow").style.display = "inline";
        document.getElementById("delivery-el").style.display = "none";
        document.getElementById("fromDate").style.display = "none";
      } else {
        lastDate = Date.today().addDays(4);
      }
    }

    if (today.is().friday()) {
      if (hour <= 14) {
        lastDate = Date.today().addDays(3);
      } else {
        lastDate = Date.today().addDays(4);
      }
    }

    if (today.is().saturday()) {
      lastDate = Date.today().addDays(3);
    }

    if (today.is().sunday()) {
      lastDate = Date.today().addDays(2);
    }

    // if (fromDate.is().saturday() || fromDate.is().sunday()) {
    //   fromDate = fromDate.next().monday();
    // }
    // var toDate = Date.today().addDays(10);
    // if (toDate.is().saturday() || toDate.is().sunday()) {
    //   toDate = toDate.next().monday();
    // }
    document.getElementById("fromDate").innerHTML = lastDate.toString("d");
    // document.getElementById('toDate').innerHTML = toDate.toString('d');
  }

  $(document).on("click", ".ajax-cart .Drawer__Close", function (e) {
    e.preventDefault();
    $("#sidebar-cart").attr("aria-hidden", true);
    $("#sidebar-cart").attr("tabindex", false);
    $("#sidebar-cart").removeClass("ajax-cart");
    $(".PageOverlay").removeClass("is-visible");
    $("html").removeClass("no-scroll");
  });

  // View reviews

  $(".view-reviews").on("click touch", function (e) {
    e.preventDefault();
    $("html, body").animate(
      {
        scrollTop: $("#stamped-main-widget").offset().top - 100,
      },
      2000
    );
  });

  $(".club__box h2").on("click touch", function () {
    $(this).closest(".club__box").toggleClass("active");
  });

  // Smile

  var findSmile = setInterval(function () {
    if ($("#smile-ui-container").length) {
      $("#smile-ui-container").css("z-index", 10000);
      clearInterval(findSmile);
    } else {
    }
  }, 500);

  // Check scroll

  // function isScrolledIntoView(elem) {
  //   var docViewTop = $(window).scrollTop();
  //   var docViewBottom = docViewTop + $(window).height();

  //   var elemTop = $(elem).offset().top;
  //   var elemBottom = elemTop + $(elem).height();

  //   return elemBottom <= docViewBottom && elemTop >= docViewTop;
  // }

  // if ($(".fixed-bar").length) {
  //   $(window).on("scroll", function () {
  //     if (isScrolledIntoView(".ProductForm__BuyButtons")) {
  //       $(".fixed-bar").removeClass("active");
  //     } else {
  //       $(".fixed-bar").addClass("active");
  //     }
  //   });
  // }
  function isScrolledIntoView(elemSelector) {
    const elem = document.querySelector(elemSelector);
    if (!elem) return false;

    const docViewTop = window.scrollY;
    const docViewBottom = docViewTop + window.innerHeight;

    const elemRect = elem.getBoundingClientRect();
    const elemTop = elemRect.top + window.scrollY;
    const elemBottom = elemTop + elem.offsetHeight;

    if (elemRect.top > 0) return true;

    return elemBottom <= docViewBottom && elemTop >= docViewTop;
  }

  const fixedBar = document.querySelector(".fixed-bar");
  if (fixedBar) {
    window.addEventListener("scroll", function () {
      if (isScrolledIntoView(".ProductForm__BuyButtons")) {
        fixedBar.classList.remove("active");
      } else {
        fixedBar.classList.add("active");
      }
    });
  }

  document.addEventListener("rebuy.init", function (event) {
    console.log("rebuy.init event", event.detail);
  });
});

document.addEventListener("rebuy.add", function (event) {
  document.documentElement.dispatchEvent(
    new CustomEvent("cart:refresh", {
      bubbles: true,
    })
  );
});

document.addEventListener("product:added", function (event) {
  setTimeout(function () {
    if (window.Rebuy && typeof window.Rebuy.init === "function") {
      window.Rebuy.init();
    }
  }, 500);
});

// Osama Code

(function () {
  const selectors = {
    productThumb: "[data-thumb-flickity]",
  };

  return;
  const thumbSwiperEl = document.querySelector(selectors.productThumb);

  if (!thumbSwiperEl) return;

  const swiperOptions = Object.assign(
    JSON.parse(thumbSwiperEl.getAttribute("data-flickity-config"))
  );

  const thumbSwiper = new window.Flickity(thumbSwiperEl, swiperOptions);
  window.addEventListener("resize", () => thumbSwiper.activate());

  const _validateDraggable = () => {
    var isActive = thumbSwiper.isActive || false;
    thumbSwiper.activate();
    return;

    // if (!isActive || !thumbSwiper.options["draggable"]) {
    //   return; // Not draggable, so nothing to do
    // }

    // if (
    //   undefined === thumbSwiper.selectedElements ||
    //   thumbSwiper.selectedElements.length === thumbSwiper.cells.length
    // ) {
    //   thumbSwiper.unbindDrag();
    // } else {
    //   thumbSwiper.bindDrag();
    // }
    // thumbSwiper.activate();
  };

  thumbSwiper.on("resize", () => {
    console.log("thumbswiper resized");
    _validateDraggable();
  });

  console.log(thumbSwiper);
  thumbSwiper.activate();
})();


/* ===========================================

Script para oculatar packs en suscripciones

============================================ */

document.addEventListener('DOMContentLoaded', () => {
  const HIDE_CLASS = 'sc-kaching-hidden';

  // ✅ Recordamos el qty del pack (2/3) y el marcador del bundle de Kaching
  let lastBundleQty = null;
  let lastKachingBundleValue = null;

  function getForm() {
    return document.querySelector('form[action="/cart/add"]');
  }

  function getKachingRoot() {
    const title = document.querySelector('.kaching-bundles__block-title');
    if (!title) return null;
    return title.closest('.kaching-bundles')
      || title.closest('[class^="kaching-bundles"]')
      || title.closest('[class*="kaching-bundles"]');
  }

  function isSubscriptionSelectedByUI() {
    // Limitar búsqueda al widget de Recharge para no pillar radios de Kaching
    const rc = document.querySelector('[data-recharge-widget], .rc-widget, .recharge-subscription-widget') || document;
    const checked = Array.from(rc.querySelectorAll('input[type="radio"]:checked'));

    for (const r of checked) {
      const box = r.closest('label, div, section') || r.parentElement;
      const text = (box?.textContent || '').replace(/\s+/g, ' ').toLowerCase();
      if (text.includes('compra única') || text.includes('compra unica')) return false;
      if (text.includes('suscríbete') || text.includes('suscribete') || text.includes('suscrib')) return true;
    }
    return null;
  }

  function isSubscriptionActiveFallback() {
    const f = getForm();
    const sp = f?.querySelector('input[name="selling_plan"], select[name="selling_plan"]');
    return !!(sp && (sp.value || '').toString().trim() !== '');
  }

  function isSubscriptionMode() {
    const ui = isSubscriptionSelectedByUI();
    if (ui === true) return true;
    if (ui === false) return false;
    return isSubscriptionActiveFallback();
  }

  function syncKachingVisibility() {
    const root = getKachingRoot();
    if (!root) return;
    root.classList.toggle(HIDE_CLASS, isSubscriptionMode());
  }

  // ✅ En compra única: restaurar qty y el marcador __kaching_bundles si lo guardamos
  function restoreForOnetime() {
    if (isSubscriptionMode()) return; // solo compra única

    const f = getForm();
    if (!f) return;

    const qty = f.querySelector('input[name="quantity"]');
    if (qty && lastBundleQty) {
      const current = parseInt((qty.value || '1'), 10);
      const desired = parseInt(String(lastBundleQty), 10);

      // Solo si se quedó en 1 (típico tras pasar por suscripción)
      if (Number.isFinite(desired) && desired > 1 && current === 1) {
        qty.value = String(desired);
        qty.dispatchEvent(new Event('input', { bubbles: true }));
        qty.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    // ✅ Restaurar el marcador del bundle para que el regalo vuelva a ser gratis
    const bundle = f.querySelector('input[name="properties[__kaching_bundles]"]');
    if (bundle && (!bundle.value || bundle.value.trim() === '') && lastKachingBundleValue) {
      bundle.value = lastKachingBundleValue;
      bundle.dispatchEvent(new Event('input', { bubbles: true }));
      bundle.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // ✅ En suscripción: guardar estado (qty + bundle marker) y neutralizar
  function sanitizeFormForSubscription() {
    const f = getForm();
    if (!f) return;
    if (!isSubscriptionMode()) return;

    // Guardar qty si venía de pack
    const qty = f.querySelector('input[name="quantity"]');
    if (qty) {
      const current = parseInt((qty.value || '1'), 10);
      if (Number.isFinite(current) && current > 1) lastBundleQty = String(current);

      qty.value = '1';
      qty.dispatchEvent(new Event('input', { bubbles: true }));
      qty.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Guardar y limpiar marcador bundle
    const bundle = f.querySelector('input[name="properties[__kaching_bundles]"]');
    if (bundle) {
      if (bundle.value && bundle.value.trim() !== '') {
        lastKachingBundleValue = bundle.value;
      }
      bundle.value = '';
    }

    // Limpiar cualquier property con kaching (por si deja flags)
    f.querySelectorAll('input[name^="properties["]').forEach(inp => {
      const name = (inp.getAttribute('name') || '').toLowerCase();
      if (name.includes('kaching')) inp.value = '';
    });
  }

  // ✅ Bloqueo de la vía Kaching SOLO en suscripción (para que no meta crema/regalo)
  const _fetch = window.fetch;
  window.fetch = function(input, init) {
    const url = typeof input === 'string' ? input : (input?.url || '');
    if (isSubscriptionMode() && url.includes('/cart/add.js') && url.includes('kaching_bundles=true')) {
      return Promise.resolve(new Response(JSON.stringify({ blocked: true }), {
        status: 200,
        headers: { 'Content-Type': 'application/json' }
      }));
    }
    return _fetch.apply(this, arguments);
  };

  // Arranque
  let tries = 0;
  const boot = setInterval(() => {
    syncKachingVisibility();
    restoreForOnetime();
    tries++;
    if (tries >= 20) clearInterval(boot); // 2s
  }, 100);

  // En cada interacción, sincroniza + restaura si es compra única
  document.addEventListener('change', () => {
    setTimeout(() => {
      syncKachingVisibility();
      restoreForOnetime();
    }, 30);
  }, true);

  document.addEventListener('click', () => {
    setTimeout(() => {
      syncKachingVisibility();
      restoreForOnetime();
    }, 30);
  }, true);

  // En submit: si es suscripción, sanitiza justo a tiempo
  const f = getForm();
  if (f) {
    f.addEventListener('submit', () => {
      sanitizeFormForSubscription();
    }, true);
  }
});


/* ===========================================

Script para añadir Recomendado de forma dinámica a la opción de 3 meses en Recharge 

============================================ */

document.addEventListener('DOMContentLoaded', () => {
  const TARGET_INTERVAL = '3 meses';
  const BADGE_TEXT = 'Recomendado';

  let __scRunning = false;
  let __scLastRun = 0;

  // Para no registrar observers duplicados
  const observedRoots = new WeakSet();

  function deepQuerySelectorAll(selector, root = document) {
    const results = [];
    const visited = new Set();

    function walk(node) {
      if (!node || visited.has(node)) return;
      visited.add(node);

      try {
        if (node.querySelectorAll) results.push(...node.querySelectorAll(selector));
      } catch {}

      // Recorremos elementos para encontrar shadowRoots
      const all = node.querySelectorAll ? node.querySelectorAll('*') : [];
      for (const el of all) {
        if (el.shadowRoot) walk(el.shadowRoot);
      }
    }

    walk(root);
    return Array.from(new Set(results));
  }

  function addBadgeToIntervalGroup(group) {
    const labels = Array.from(group.querySelectorAll('label'));
    for (const label of labels) {
      const intervalEl = label.querySelector('.rc-plans-button__interval');
      if (!intervalEl) continue;

      const intervalText = (intervalEl.textContent || '')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();

      if (intervalText !== TARGET_INTERVAL.toLowerCase()) continue;

      const btn = label.querySelector('.rc-plans-button');
      if (!btn) continue;

      // Si ya existe, OK (pero NO salimos del todo: a veces hay 2 widgets)
      if (btn.querySelector('.sc-rc-badge')) return true;

      const badge = document.createElement('span');
      badge.className = 'sc-rc-badge';
      badge.textContent = BADGE_TEXT;

      btn.style.position = 'relative';
      badge.setAttribute(
        'style',
        'position:absolute;top:-10px;right:10px' +
        'display:inline-block;padding:4px 10px;' +
        'font-size:11px;font-weight:700;line-height:1;' +
        'background:red;color:#fff;white-space:nowrap;' +
        'box-shadow:0 2px 6px rgba(0,0,0,.12);' 
      );

      btn.appendChild(badge);
      return true;
    }
    return false;
  }

  function injectEverywhere() {
    const groups = deepQuerySelectorAll('fieldset.rc-plans-button-group');
    let didAny = false;
    for (const g of groups) didAny = addBadgeToIntervalGroup(g) || didAny;
    return didAny;
  }

  function safeInject(minIntervalMs = 120) {
    const now = Date.now();
    if (__scRunning) return;
    if (now - __scLastRun < minIntervalMs) return;

    __scRunning = true;
    __scLastRun = now;

    try {
      observeAllShadowRoots(); // <- clave
      injectEverywhere();
    } finally {
      __scRunning = false;
    }
  }

  // Observa también mutaciones dentro de shadowRoots
  function observeAllShadowRoots() {
    const hosts = deepQuerySelectorAll('*'); // ya recorre shadow; nos vale para hallar hosts
    for (const el of hosts) {
      if (!el.shadowRoot) continue;
      const root = el.shadowRoot;
      if (observedRoots.has(root)) continue;

      observedRoots.add(root);
      const mo = new MutationObserver(() => {
        clearTimeout(window.__scRcBadgeT2);
        window.__scRcBadgeT2 = setTimeout(() => safeInject(120), 60);
      });
      mo.observe(root, { childList: true, subtree: true });
    }
  }

  // 1) Arranque
  let tries = 0;
  const boot = setInterval(() => {
    safeInject(0);
    tries++;
    if (tries > 25) clearInterval(boot);
  }, 100);

  // 2) Burst corto (lo dispara cualquier click relacionado con el widget/tabs)
  function burstInject() {
    let i = 0;
    const t = setInterval(() => {
      safeInject(0);
      i++;
      if (i > 50) clearInterval(t);
    }, 30);
  }

  // Click robusto: busca texto en el composedPath (funciona con shadow DOM)
  function composedTextIncludes(e, needle) {
    const path = e.composedPath ? e.composedPath() : [];
    for (const node of path) {
      if (!node || !node.textContent) continue;
      const t = (node.textContent || '').toLowerCase();
      if (t.includes(needle)) return true;
    }
    return false;
  }

  document.addEventListener('click', (e) => {
    // si clican suscripción/compra única, disparamos burst
    if (
      composedTextIncludes(e, 'suscríb') ||
      composedTextIncludes(e, 'suscrib') ||
      composedTextIncludes(e, 'compra única') ||
      composedTextIncludes(e, 'compra unica') ||
      composedTextIncludes(e, 'one-time') ||
      composedTextIncludes(e, 'one time')
    ) {
      burstInject();
    }
  }, true);

  // 3) Observer del DOM normal (como ya tenías)
  const mo = new MutationObserver(() => {
    clearTimeout(window.__scRcBadgeT);
    window.__scRcBadgeT = setTimeout(() => safeInject(200), 120);
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // 4) Extra: cuando vuelves a la pestaña, reinyecta (esto “arregla” el síntoma que notabas)
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) burstInject();
  });
});

/* ================================
   SC Sticky price sync (SAFE)
   - Subscription (selling_plan allocation) price
   - One-time base price + compare_at (if discount)
   - Kaching selected deal price + full price (if present)
   No global MutationObserver
================================== */
(() => {
  if (window.__SC_STICKY_SP_INIT__) return;
  window.__SC_STICKY_SP_INIT__ = true;

  const isProduct =
    document.body.classList.contains('template-product') ||
    location.pathname.includes('/products/');
  if (!isProduct) return;

  const norm = (s) => (s || '').replace(/\s+/g, ' ').trim();

  const onReady = (fn) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else fn();
  };

  const throttle = (fn, wait = 120) => {
    let last = 0;
    let t = null;
    return (...args) => {
      const now = Date.now();
      const remaining = wait - (now - last);
      if (remaining <= 0) {
        last = now;
        fn(...args);
      } else {
        clearTimeout(t);
        t = setTimeout(() => {
          last = Date.now();
          fn(...args);
        }, remaining);
      }
    };
  };

  // Shopify inputs
  function getVariantId() {
    const v = document.querySelector('form[action*="/cart/add"] [name="id"]')?.value;
    return v ? String(v) : '';
  }

  function getSellingPlanId() {
    const sp = document.querySelector('input[name="selling_plan"]')?.value;
    return sp ? String(sp) : '';
  }

  // Money formatting from cents
  function formatMoneyFromCents(cents) {
    const n = Number(cents);
    if (!Number.isFinite(n)) return '';
    const amount = n / 100;

    const currency =
      (window.Shopify && Shopify.currency && Shopify.currency.active) ||
      document.documentElement.getAttribute('data-shopify-currency') ||
      'EUR';

    try {
      return new Intl.NumberFormat('es-ES', { style: 'currency', currency }).format(amount);
    } catch {
      return `${amount.toFixed(2).replace('.', ',')}€`;
    }
  }

  // Product JSON cache
  let productCache = null;
  let productCachePromise = null;

  function getHandleFromUrl() {
    const parts = location.pathname.split('/').filter(Boolean);
    const i = parts.indexOf('products');
    return i >= 0 ? parts[i + 1] : null;
  }

  async function getProductJson() {
    if (productCache) return productCache;
    if (productCachePromise) return productCachePromise;

    const handle = getHandleFromUrl();
    if (!handle) return null;

    productCachePromise = fetch(`/products/${handle}.js`, { credentials: 'same-origin' })
      .then((r) => (r.ok ? r.json() : null))
      .then((j) => (productCache = j))
      .catch(() => null)
      .finally(() => {
        productCachePromise = null;
      });

    return productCachePromise;
  }

  function findVariant(product, variantId) {
    if (!product?.variants?.length) return null;
    return product.variants.find((v) => String(v.id) === String(variantId)) || null;
  }

  function getBasePriceCents(variant) {
    const cents = variant?.price;
    return cents != null ? Number(cents) : null;
  }

  function findAllocationCents(variant, sellingPlanId) {
    const allocs = variant?.selling_plan_allocations;
    if (!Array.isArray(allocs) || !allocs.length) return null;

    const a = allocs.find((x) => String(x.selling_plan_id) === String(sellingPlanId));
    if (!a) return null;

    return a.per_delivery_price ?? a.price ?? null;
  }

  // Sticky elements (highlight + compareAt + button price)
  function getStickyEls() {
    return {
      highlight: Array.from(
        document.querySelectorAll(
          '.ProductMeta__PriceList .ProductMeta__Price.Price.u-h4.Price--highlight'
        )
      ),
      compareAt: Array.from(
        document.querySelectorAll(
          '.ProductMeta__PriceList .ProductMeta__Price.Price.u-h4.Price--compareAt'
        )
      ),
      buttonPrice: Array.from(document.querySelectorAll('a.fixed__button.Button'))
        .map((a) => {
          const spans = Array.from(a.querySelectorAll('span'));
          return spans
            .slice()
            .reverse()
            .find((sp) => /€/.test(norm(sp.textContent)) && /[0-9]/.test(norm(sp.textContent)));
        })
        .filter(Boolean),
    };
  }

  function setStickyPrices(priceText, compareText = '') {
    const price = norm(priceText);
    const compare = norm(compareText);
    if (!price) return;

    const { highlight, compareAt, buttonPrice } = getStickyEls();

    [...highlight, ...buttonPrice].forEach((el) => {
      if (el && norm(el.textContent) !== price) el.textContent = price;
    });

    const showCompare = !!compare && compare !== price;

    compareAt.forEach((el) => {
      if (!el) return;
      el.style.display = showCompare ? '' : 'none';
      if (showCompare && norm(el.textContent) !== compare) el.textContent = compare;
    });
  }

  // Kaching selected: price + (optional) full price
  function getKachingSelectedPrices() {
    const selectedBar = document.querySelector('.kaching-bundles__bar.kaching-bundles__bar--selected');
    if (!selectedBar) return null;

    const price = norm(selectedBar.querySelector('.kaching-bundles__bar-price')?.textContent);
    if (!price || !/€/.test(price)) return null;

    const full = norm(selectedBar.querySelector('.kaching-bundles__bar-full-price')?.textContent);
    const compare = full && /€/.test(full) && full !== price ? full : '';

    return { price, compare };
  }

  // Sync core (NO observers)
  const syncStickyPrice = throttle(async () => {
    try {
      const variantId = getVariantId();
      if (!variantId) return;

      const sellingPlanId = getSellingPlanId();

      // 1) Subscription wins: only current price
      if (sellingPlanId) {
        const product = await getProductJson();
        if (!product) return;

        const variant = findVariant(product, variantId);
        if (!variant) return;

        const cents = findAllocationCents(variant, sellingPlanId);
        if (cents == null) return;

        setStickyPrices(formatMoneyFromCents(cents), '');
        return;
      }

      // 2) One-time: Kaching selected
      const kaching = getKachingSelectedPrices();
      if (kaching) {
        setStickyPrices(kaching.price, kaching.compare);
        return;
      }

      // 3) One-time: base variant price + compare_at if discount
      const product = await getProductJson();
      if (!product) return;

      const variant = findVariant(product, variantId);
      if (!variant) return;

      const baseCents = getBasePriceCents(variant);
      if (baseCents == null) return;

      const priceText = formatMoneyFromCents(baseCents);

      const compareCents =
        variant?.compare_at_price != null ? Number(variant.compare_at_price) : null;

      const hasDiscount =
        Number.isFinite(compareCents) && compareCents > Number(baseCents);

      const compareText = hasDiscount ? formatMoneyFromCents(compareCents) : '';

      setStickyPrices(priceText, compareText);
    } catch (err) {
      console.warn('[SC Sticky] sync error:', err);
    }
  }, 120);

  function safeBurst() {
    syncStickyPrice();
    setTimeout(syncStickyPrice, 60);
    setTimeout(syncStickyPrice, 180);
  }

  onReady(() => {
    try {
      safeBurst();

      document.addEventListener(
        'change',
        (e) => {
          const name = e?.target?.name;

          if (name === 'selling_plan' || name === 'id' || name === 'purchaseOption') {
            safeBurst();
            return;
          }

          if (typeof name === 'string' && name.startsWith('kaching-bundles-deal-')) {
            safeBurst();
          }
        },
        true
      );

      document.addEventListener(
        'click',
        (e) => {
          const within = e.target?.closest?.('.kaching-bundles__bars');
          if (within) safeBurst();
        },
        true
      );

      document.addEventListener('variant:change', safeBurst);
      document.addEventListener('product:variant-change', safeBurst);

      window.addEventListener(
        'scroll',
        throttle(() => syncStickyPrice(), 250),
        { passive: true }
      );
    } catch (err) {
      console.warn('[SC Sticky] init error:', err);
    }
  });
})();





(() => {
  if (window.__SC_MAIN_PRICE_ONLY_INIT__) return;
  window.__SC_MAIN_PRICE_ONLY_INIT__ = true;

  const isProductPage =
    document.body.classList.contains('template-product') ||
    location.pathname.includes('/products/');

  if (!isProductPage) return;

  const norm = (s) => (s || '').replace(/\s+/g, ' ').trim();

  const onReady = (fn) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  };

  const throttle = (fn, wait = 120) => {
    let last = 0;
    let timer = null;

    return (...args) => {
      const now = Date.now();
      const remaining = wait - (now - last);

      if (remaining <= 0) {
        last = now;
        fn(...args);
      } else {
        clearTimeout(timer);
        timer = setTimeout(() => {
          last = Date.now();
          fn(...args);
        }, remaining);
      }
    };
  };

  function getAddToCartForm() {
    return document.querySelector('form[action*="/cart/add"]');
  }

  function getVariantId() {
    const form = getAddToCartForm();
    const input = form?.querySelector('[name="id"]');
    return input?.value ? String(input.value) : '';
  }

  function getSellingPlanInput() {
    return document.querySelector('input[name="selling_plan"]');
  }

  function getSellingPlanId() {
    const input = getSellingPlanInput();
    return input?.value ? String(input.value) : '';
  }

  function formatMoneyFromCents(cents) {
    const n = Number(cents);
    if (!Number.isFinite(n)) return '';

    const amount = n / 100;
    const currency =
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
      document.documentElement.getAttribute('data-shopify-currency') ||
      'EUR';

    try {
      return new Intl.NumberFormat('es-ES', {
        style: 'currency',
        currency
      }).format(amount);
    } catch {
      return `${amount.toFixed(2).replace('.', ',')}€`;
    }
  }

  let productCache = null;
  let productCachePromise = null;

  function getHandleFromUrl() {
    const parts = location.pathname.split('/').filter(Boolean);
    const i = parts.indexOf('products');
    return i >= 0 ? parts[i + 1] : null;
  }

  async function getProductJson() {
    if (productCache) return productCache;
    if (productCachePromise) return productCachePromise;

    const handle = getHandleFromUrl();
    if (!handle) return null;

    productCachePromise = fetch(`/products/${handle}.js`, {
      credentials: 'same-origin'
    })
      .then((r) => (r.ok ? r.json() : null))
      .then((j) => {
        productCache = j;
        return j;
      })
      .catch(() => null)
      .finally(() => {
        productCachePromise = null;
      });

    return productCachePromise;
  }

  function findVariant(product, variantId) {
    if (!product?.variants?.length) return null;
    return product.variants.find((v) => String(v.id) === String(variantId)) || null;
  }

  function getSubscriptionPriceCents(variant, sellingPlanId) {
    const allocations = variant?.selling_plan_allocations;
    if (!Array.isArray(allocations) || !allocations.length) return null;

    const match = allocations.find(
      (item) => String(item.selling_plan_id) === String(sellingPlanId)
    );

    if (!match) return null;

    return match.per_delivery_price ?? match.price ?? null;
  }

  function getMainPriceRoot() {
    return document.querySelector('.ProductMeta__PriceList');
  }

  function getMainPriceEls() {
    const root = getMainPriceRoot();
    if (!root) return null;

    const priceEls = Array.from(root.querySelectorAll('.ProductMeta__Price'));
    const compareEl =
      root.querySelector('.ProductMeta__Price.Price--compareAt') || null;

    const mainEl =
      root.querySelector('.ProductMeta__Price.Price--highlight') ||
      priceEls.find((el) => !el.classList.contains('Price--compareAt')) ||
      null;

    const badgeEl = root.querySelector('.ProductMeta__SavePercent') || null;
    const badgeWrap = badgeEl ? badgeEl.parentElement : null;

    return { root, mainEl, compareEl, badgeEl, badgeWrap };
  }

  function setMainPriceUI(priceText, compareText = '') {
    const els = getMainPriceEls();
    if (!els || !els.mainEl) return;

    const price = norm(priceText);
    const compare = norm(compareText);
    const showCompare = !!compare && compare !== price;

    els.mainEl.textContent = price;

    if (els.compareEl) {
      els.compareEl.style.display = showCompare ? '' : 'none';
      if (showCompare) {
        els.compareEl.textContent = compare;
      }
    }

    if (els.badgeEl && els.badgeWrap) {
      const parseDisplayedMoney = (txt) => {
        const cleaned = String(txt)
          .replace(/[^\d,.-]/g, '')
          .replace(/\./g, '')
          .replace(',', '.');
        const num = parseFloat(cleaned);
        return Number.isFinite(num) ? num : null;
      };

      const priceNum = parseDisplayedMoney(price);
      const compareNum = showCompare ? parseDisplayedMoney(compare) : null;

      let badgeText = '';

      if (compareNum != null && priceNum != null && compareNum > priceNum) {
        const percent = Math.round(((compareNum - priceNum) / compareNum) * 100);
        badgeText = `Ahorra ${percent}%`;
        if (priceNum >= 50) badgeText += ' + ENVÍO GRATIS HOY';
      } else if (priceNum != null && priceNum >= 50) {
        badgeText = 'ENVÍO GRATIS HOY';
      }

      if (badgeText) {
        els.badgeEl.textContent = badgeText;
        els.badgeWrap.style.display = '';
      } else {
        els.badgeWrap.style.display = 'none';
      }
    }
  }

  async function syncMainPrice() {
    try {
      const variantId = getVariantId();
      if (!variantId) return;

      const product = await getProductJson();
      if (!product) return;

      const variant = findVariant(product, variantId);
      if (!variant) return;

      const sellingPlanId = getSellingPlanId();

      if (sellingPlanId) {
        const subPriceCents = getSubscriptionPriceCents(variant, sellingPlanId);

        if (subPriceCents != null) {
          const compareCents =
            variant.compare_at_price != null ? Number(variant.compare_at_price) : null;

          const compareText =
            Number.isFinite(compareCents) && compareCents > Number(subPriceCents)
              ? formatMoneyFromCents(compareCents)
              : '';

          setMainPriceUI(formatMoneyFromCents(subPriceCents), compareText);
          return;
        }
      }

      const basePriceCents = variant.price != null ? Number(variant.price) : null;
      if (basePriceCents == null) return;

      const compareCents =
        variant.compare_at_price != null ? Number(variant.compare_at_price) : null;

      const compareText =
        Number.isFinite(compareCents) && compareCents > basePriceCents
          ? formatMoneyFromCents(compareCents)
          : '';

      setMainPriceUI(formatMoneyFromCents(basePriceCents), compareText);
    } catch (err) {
      console.warn('[SC Main Price Only] sync error:', err);
    }
  }

  const syncMainPriceThrottled = throttle(syncMainPrice, 120);

  function burstSync() {
    syncMainPriceThrottled();
    setTimeout(syncMainPriceThrottled, 60);
    setTimeout(syncMainPriceThrottled, 180);
    setTimeout(syncMainPriceThrottled, 320);
    setTimeout(syncMainPriceThrottled, 500);
  }

  function setupSellingPlanObserver() {
    const input = getSellingPlanInput();
    if (!input || input.__scObserverAttached) return;

    input.__scObserverAttached = true;

    let lastValue = input.value;

    const observer = new MutationObserver(() => {
      const nextValue = input.value;
      if (nextValue !== lastValue) {
        lastValue = nextValue;
        burstSync();
      }
    });

    observer.observe(input, {
      attributes: true,
      attributeFilter: ['value']
    });

    input.addEventListener('change', burstSync, true);
    input.addEventListener('input', burstSync, true);

    const nativeSet = Object.getOwnPropertyDescriptor(
      window.HTMLInputElement.prototype,
      'value'
    )?.set;

    if (nativeSet && !input.__scValuePatched) {
      input.__scValuePatched = true;

      Object.defineProperty(input, 'value', {
        get() {
          return input.getAttribute('value') ?? '';
        },
        set(v) {
          nativeSet.call(this, v);
          burstSync();
        }
      });
    }
  }

  function setupGlobalWatchers() {
    document.addEventListener(
      'change',
      (e) => {
        const name = e?.target?.name;

        if (
          name === 'id' ||
          name === 'selling_plan' ||
          name === 'purchaseOption' ||
          (typeof name === 'string' && name.startsWith('options['))
        ) {
          burstSync();
        }
      },
      true
    );

    document.addEventListener(
      'input',
      (e) => {
        const name = e?.target?.name;

        if (
          name === 'selling_plan' ||
          name === 'purchaseOption' ||
          (typeof name === 'string' && name.startsWith('options['))
        ) {
          burstSync();
        }
      },
      true
    );

    document.addEventListener(
      'click',
      (e) => {
        if (
          e.target?.closest?.('.PackSelector__Item') ||
          e.target?.closest?.('.rc-widget') ||
          e.target?.closest?.('.rc-container') ||
          e.target?.closest?.('.rc-option') ||
          e.target?.closest?.('.rc-radio') ||
          e.target?.closest?.('.rc-radio__label') ||
          e.target?.closest?.('.rc-selling-plans') ||
          e.target?.closest?.('.rc-template__legacy-radio') ||
          e.target?.closest?.('label[for*="selling_plan"]') ||
          e.target?.closest?.('[data-selling-plan-group]') ||
          e.target?.closest?.('[data-purchase-option]')
        ) {
          burstSync();
        }
      },
      true
    );

    document.addEventListener('variant:change', burstSync);
    document.addEventListener('product:variant-change', burstSync);

    const bodyObserver = new MutationObserver(() => {
      setupSellingPlanObserver();
    });

    bodyObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  onReady(() => {
    setupSellingPlanObserver();
    setupGlobalWatchers();
    burstSync();
  });
})();
